console.log('%c Developed by XTO ', 'background: blue; color: white; font-size: 17px;')
console.log('%c www.xto.es ', 'font-size: 17px;')

const ajax = require('./components/ajax')
const video = require('./components/video')
const general = require('./components/general')

//Initialise our components on jQuery.ready…
jQuery(function ($) {
	ajax.init($)
	if ($('.course-section__video').length > 0) {
		video.init($)
	}
	if ($('.aside-container').length > 0) {
		general.init($)
	}
})
// 